import { AdvancedReorderConfig } from "./advanced-reorder-config";

export class ItemOrders {
  storeId: number;
  asin: string;
  included: boolean;
  quantity: number = 0;
  days: number = 0;
  orderFor: number = 0;
  setting: AdvancedReorderConfig;
}